<template>
  <div class="management-page-outer-container">
    <router-view />
    <div
      v-if="$route.name === 'about-licenses'"
      class="data-table management-main-list-data-table"
    >
      <licenses-list>
        <v-layout style="height: 90px;" />
      </licenses-list>
    </div>
  </div>
</template>

<script>
import LicensesList from "@/components/User/Licenses/LicensesList";
export default {
  name: "Licenses",
  components: { LicensesList }
};
</script>



// WEBPACK FOOTER //
// src/components/User/Licenses/Licenses.vue